import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft, FaWater } from "react-icons/fa"; // Back and Logo icons
import { logout } from "../services/authService"; // Import logout functionality

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    const success = logout(); // Call the logout function
    if (success) {
      navigate("/"); // Redirect to login page
      window.location.reload(); // Optional: Force state reset
    } else {
      console.error("Logout failed");
    }
  };

  return (
    <header className="bg-gray-900 text-white fixed top-0 left-0 w-full shadow-md z-50">
    <div className="flex justify-between items-center px-4 py-3">

      {/* Back Button */}
      {location.pathname !== "/home" ? (
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm text-gray-300 hover:text-blue-400"
        >
          <FaArrowLeft className="text-base" />
          <span>Back</span>
        </button>
      ) : (
        <div /> // Empty div for spacing
      )}

      {/* Logo + App Name */}
      <div className="flex items-center gap-2 text-white">
        <FaWater className="text-xl text-blue-500" />
        <span className="text-base font-bold">R B Caters & Water</span>
      </div>

      {/* Logout */}
      <button
        onClick={handleLogout}
        className="text-sm bg-red-600 px-3 py-1 rounded hover:bg-red-700 transition"
      >
        Logout
      </button>
    </div>
  </header>
);
};

export default Header;